import { ReactElement } from "react";

export const Jobs = (): ReactElement => {
  return (
    <svg
      width="1em"
      height="1em"
      stroke="currentColor"
      strokeWidth="0.075em"
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M24.0485 13.1852C20.1243 13.1852 14 12.9351 14 16.8593C14 37.4847 14 45.3745 14 66H59C59 66 59 37.3593 59 16.8593C59 12.94 48.5146 13.1852 48.5146 13.1852M24.0485 13.1852V16.8593C33.6031 16.8593 48.5146 16.8593 48.5146 16.8593V13.1852M24.0485 13.1852V9.05185H29.7282C29.7282 9.05185 30.6519 6.42969 31.9126 5.37778C33.3078 4.21366 36.2816 4 36.2816 4C36.2816 4 38.8928 4.39429 40.2136 5.37778C41.6059 6.41446 42.835 9.05185 42.835 9.05185H48.5146V13.1852" />
      <circle cx="36.4" cy="11.5" r="1.5" fill="currentColor" />
      <line x1="34.35" y1="32.65" x2="51.65" y2="32.65" />
      <line x1="34.35" y1="50.65" x2="51.65" y2="50.65" />
      <path d="M22.5 47.9004H27.5C27.8314 47.9004 28.0996 48.1686 28.0996 48.5V53.5C28.0996 53.8314 27.8314 54.0996 27.5 54.0996H22.5C22.1686 54.0996 21.9004 53.8314 21.9004 53.5V48.5C21.9004 48.1686 22.1686 47.9004 22.5 47.9004Z" />
      <path d="M22.5 32.5L24.5 34.5L27.5 28.5" />
    </svg>
  );
};
